// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_jt-0";
export var fulfillmentPanelBody = "_jt-1";